import styled from "styled-components";
import { device } from "../../../../helpers/style";

export const Container = styled.div`
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    width: 600px;

    @media ${device.phone} {
        width: 90vw;
        max-width: 550px;
    } ;
`;
export const StepContainer = styled.div`
    width: 100%;

    @media ${device.phone} {
        margin-top: 85px;
    } ;
`;
export const Heading = styled.div`
    margin-bottom: 20px;
    font-size: 30px;
    font-weight: 500;
    text-align: center;
    font-family: Cairo, QuranFont, urdu, sans-serif;
`;

type Props = {
    title: string;
    children: JSX.Element | JSX.Element[];
};
export default function Step({ title, children }: Props) {
    return (
        <StepContainer>
            <Heading>{title}</Heading>
            {children}
        </StepContainer>
    );
}
